import {MvsCoreService} from "../../../../../../../../core/shared/service/mvs-core.service";
import {MvsCrudService} from "../../../../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {OutletContentDto} from "../../../../../../model/dto/entity/outlet-content.dto";
import {OutletDto} from "../../../../../../model/dto/entity/outlet.dto";
import {takeUntil} from "rxjs/operators";
import {OutletService} from "../../../../../../service/api/outlet.service";
import {Subject} from "rxjs";
import {ObjectRequestList} from "../../../../../../../../core/shared/dto/object/request/object-request-list";
import {FilterCriteria} from "../../../../../../../../core/shared/filter/api/filter.criteria";
import {OutletContentService} from "../../../../../../service/api/outlet-content.service";
import {OutletContentFromJsonRequestDto} from "../../../../../../model/dto/entity/outlet-content-from-json-request.dto";

@Component({
    selector: 'ol-outlet-create-content',
    templateUrl: 'ol-outlet-create-content.component.html',
    standalone: false
})
export class OlOutletCreateContentComponent implements OnInit, OnChanges, OnDestroy {
    outletBlogGhostWriterService: MvsCrudService;
    @Input() outletContentTypeId: number;
    @Input() outletId: number;
    @Output() onOutletContentCreation = new EventEmitter<OutletContentDto>();

    outletContentForm: FormGroup;
    outlets: OutletDto[] = [];        // loaded list of available outlets
    ghostWriters: any[] = [];   // loaded list of available writers

    busy = false;
    initialized = false;
    promptText = '';
    promptGenerated = false;


    private readonly destroy$ = new Subject<void>();

    constructor(
        protected coreService: MvsCoreService,
        
        private fb: FormBuilder,
        protected outletService: OutletService,
        protected outletContentService: OutletContentService) {
        this.outletBlogGhostWriterService = this.coreService.getCrudService("ol.OutletBlogGhostWriter");

    }

    ngOnInit(): void {
        this.initComponent();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.initialized) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }

    /**
     * Initialize the component.
     */
    private initComponent(): void {

        if (!this.outletContentTypeId || !this.outletId) {
            console.error(`either outletContentTypeId or outletId is missing in ${this.outletId} outlet and ${this.outletContentTypeId} outletContentTypeId`);
            return;
        }

        this.buildForm();
        this.refreshComponent();
    }

    /**
     * Refresh component state (e.g., reload data).
     */
    private refreshComponent(): void {
        this.getOutlets();
        this.getGhostWriters();
        this.initialized = true;
    }

    getOutlets(): void {
        this.outletService.get(this.outletId).pipe(takeUntil(this.destroy$)).subscribe({
            next: (outlet: OutletDto) => {
                this.outlets = [outlet];

            }
        });
    }

    getGhostWriters() {
        const objectRequestList = ObjectRequestList.createBasic(false,
            [FilterCriteria.create('outlet', FilterCriteria.cOperatorEqual, this.outletId)],
            []
        );

        this.outletBlogGhostWriterService.list(objectRequestList).subscribe(result => {
            if (result.entries.length > 0) {
                this.ghostWriters = result.entries;
            } else {
                this.ghostWriters = [];
            }
        }, error => {
            this.ghostWriters = [];
        });

    }

    /**
     * Build reactive form structure.
     */
    private buildForm(): void {
        this.outletContentForm = this.fb.group({
            outletId: [this.outletId, Validators.required],
            writerId: [null, Validators.required],
            topic: ['', [Validators.required, Validators.minLength(3)]],
            json: ['', [Validators.minLength(3)]]
        });
    }


    // === GETTERS for template convenience ===
    get outletIdCtrl() {
        return this.outletContentForm.get('outletId');
    }

    get writerIdCtrl() {
        return this.outletContentForm.get('writerId');
    }

    get topicCtrl() {
        return this.outletContentForm.get('topic');
    }

    get jsonCtrl() {
        return this.outletContentForm.get('json');
    }

    // === BUTTON ACTIONS ===
    async submit(): Promise<void> {


        if (this.busy || this.outletContentForm.invalid) return;
        this.busy = true;

        const ghostWriterId = this.outletContentForm.get('writerId').value;
        const topic = this.outletContentForm.get('topic').value;

        this.outletContentService.createOutletContent(this.outletId, this.outletContentTypeId,ghostWriterId, topic).subscribe(result => {
            this.onOutletContentCreation.emit(result);
            this.busy = false;
        },error => {
            this.busy = false;
        })

    }

    async createPrompt(): Promise<void> {

        if (this.busy || this.outletContentForm.invalid) {
            return;
        }

        this.busy = true;

        const ghostWriterId = this.outletContentForm.get('writerId').value;
        const topic = this.outletContentForm.get('topic').value;

        this.outletContentService.generatePrompt(this.outletId, this.outletContentTypeId,ghostWriterId, topic).subscribe(result => {

            this.promptText = result;
            this.promptGenerated = true;
            this.busy = false;
        },error => {
            this.busy = false;
        });

    }

    copyPromptToClipboard(): void {
        navigator.clipboard.writeText(this.promptText);
    }

    async createFromJson(): Promise<void> {
        if (this.busy || this.outletContentForm.invalid || !this.jsonCtrl.value) return;
        this.busy = true;

        const outletContentFromJsonRequestDto = new OutletContentFromJsonRequestDto();
        const ghostWriterId = this.outletContentForm.get('writerId').value;

        outletContentFromJsonRequestDto.outletId = this.outletId;
        outletContentFromJsonRequestDto.outletContentTypeId = this.outletContentTypeId;
        outletContentFromJsonRequestDto.json = this.jsonCtrl.value;
        outletContentFromJsonRequestDto.ghostWriterId = ghostWriterId;

        this.outletContentService.createOutletContentFromJson(outletContentFromJsonRequestDto).subscribe(result => {
            this.promptText = null;
            this.onOutletContentCreation.emit(result);
            this.busy = false;
        },error => {
            this.busy = false;
        });

    }
}